import React from 'react';
import styled from 'styled-components';
import ServiceWorkspace from '../../components/services/ServiceWorkspace';

const Wrap = styled.div`
  width: 100%;
  display: grid;
  justify-items: center;
  padding: 1.5rem 1rem 2rem;
  box-sizing: border-box;
`;

const Max = styled.div`
  width: 100%;
  max-width: 1160px;
  display: grid;
  gap: 18px;
`;

export default function ClientServicesPage() {
  return (
    <Wrap>
      <Max>
        <ServiceWorkspace mode="client" />
      </Max>
    </Wrap>
  );
}
